function verify_ads_viewed(json_object) {
    console.log("verify_ads_viewed OBJECT", json_object);
    var matched = 0;
    var unmatched = 0;
    var viewed_ads = json_object['impressions_history_ads_seen'];
    for (var i = 0; i < viewed_ads.length; i++) {
        var item = viewed_ads[i]['string_map_data'];
        if ('Author' in item && 'Time' in item) {
            matched++;
        } else {
            console.log("Unmatch at", item);
            unmatched++;
        }
    }
    if (matched > 0) {
        return true;
    }
    else {
        return false;
    }
}

function verify_posts_viewed(json_object) {
    console.log("verify_posts_viewed OBJECT", json_object);
    var matched = 0;
    var unmatched = 0;
    var viewed_posts = json_object['impressions_history_posts_seen'];
    for (var i = 0; i < viewed_posts.length; i++) {
        var item = viewed_posts[i]['string_map_data'];
        if ('Author' in item && 'Time' in item) {
            matched++;
        } else {
            console.log("Unmatch at", item);
            unmatched++;
        }
    }
    if (matched > 0) {
        return true;
    }
    else {
        return false;
    }
}

function verify_videos_watched(json_object) {
    console.log("verify_videos_watched OBJECT", json_object);
    var matched = 0;
    var unmatched = 0;
    var viewed_ads = json_object['impressions_history_videos_watched'];
    for (var i = 0; i < viewed_ads.length; i++) {
        var item = viewed_ads[i]['string_map_data'];
        if ('Author' in item && 'Time' in item) {
            matched++;
        } else {
            console.log("Unmatch at", item);
            unmatched++;
        }
    }
    if (matched > 0) {
        return true;
    }
    else {
        return false;
    }
}

function updateCommentValue(jsonObj) {
    if (jsonObj && typeof jsonObj === 'object') {
        if (jsonObj.Comment && jsonObj.Comment.value !== undefined) {
            jsonObj.Comment.value = "redacted";
        }
        for (const key in jsonObj) {
            if (jsonObj[key] && typeof jsonObj[key] === 'object') {
                updateCommentValue(jsonObj[key]);
            }
        }
    } else if (Array.isArray(jsonObj)) {
        jsonObj.forEach(item => updateCommentValue(item));
    }
}

function verify_comments(json_object) {
    console.log('verify comments object:', json_object);
    updateCommentValue(json_object);
    return json_object;
}

export function checkAdsViewed(ads_viewed) {
    return verify_ads_viewed(ads_viewed);
}

export function checkPostsViewed(posts_viewed) {
    return verify_posts_viewed(posts_viewed);
}

export function checkVideosWatched(videos_watched) {
    return verify_videos_watched(videos_watched);
}

export function getInstagramComments(jsonObj) {
    return verify_comments(jsonObj);
}
